export default "__VITE_ASSET__E2WKlOI1__"